<template>
  <div class="login">
    <div class="t1">

    </div>
    <div class="t2">
      <div class="inp1">
        <span> {{ $lang(42618)}} </span>
        <el-input class="inp2" v-model="put.mail" :placeholder="$lang(42625)"></el-input>
      </div>
      <div class="inp1">
        <span> {{ $lang(42619)}} </span>
        <el-input class="inp2" :placeholder="$lang(42626)" v-model="put.pwd" show-password></el-input>
      </div>
      <div class="btn">
        <el-button class="btn1" type="primary" @click="sbmt">{{ $lang(42624)}} </el-button>
      </div>

      <div class="remark">
        <span style="color:red">*</span>
        <span>{{ $lang(42620)}} </span>
        <span style="color: rgb(250 116 21);"> {{ $lang(42621)}}



        </span>

      </div>
        <div class="remark" style="color: rgb(250 116 21);">
          <span> {{ $lang(70080)}} </span>
        </div>
      <div class="remark txtmid">
        <span style="color:red">*</span>
        <span><el-checkbox v-model="checked"> </el-checkbox> {{ $lang(70068)}} </span>
        <span style="color: rgb(250 116 21);" @click="show_page(6)">《{{ $lang(70069)}}》 </span>
        <span style="color: rgb(250 116 21);" @click="show_page(5)" > 《{{ $lang(70070)}}》 </span>
      </div>

        <div class="remark wxbox">
          <el-button type="success"   icon="el-icon-chat-dot-round" @click="bind1()"  >  {{$lang(51056)}}  </el-button>
        </div>

      <!-- <div class="remark2">
        <span>{{ $lang(42622)}} </span>
        <span style="color:rgb(250 116 21);"> {{ $lang(42623)}} </span>
      </div> -->



      <div class="remark2">
        <span style="color:rgb(250 116 21);" @click="jump('/reg')">{{ $lang(50118)}} </span> &nbsp; &nbsp;&nbsp;
        <span style="color:rgb(250 116 21);" @click="jump('/rkb')">{{ $lang(50127)}} </span>

      </div>
    </div>

    <div class="t3">
      <i class="el-icon-close" @click="jump('/')"></i>
    </div>

    <el-dialog :title="$lang(51060)" :visible.sync="show">
      <div class="tcwx">
        <img class="tcqrcode" :src="qrcode" alt="">
        <div class="qrtxt">
          {{$lang(51061)}}
          <br />
          {{$lang(51062)}}
        </div>
      </div>
    </el-dialog>

    <page_tc ref="pag_tc"></page_tc>
  </div>
</template>

<script>
import page_tc from '../../components/page_tc.vue';
export default {
  components: { page_tc },
    name:"login",
    data() {
        return {
          put : {
            mail: '',
            pwd: '',
          },
          show : false,
          checked : true,

        }
    },
    methods:{
      show_page(id) {
        // alert(id)

        this.$refs.pag_tc.f5(id)
      },

      bind1() {
        this.get("/pub/pc_qa_login").then((e) => {

          this.qrcode = e.url
          this.lg_id = e.id
          this.show = true
          this.bind2()

        });
      },
      bind2() {
        let ths = this
        if (!this.show) {
          return
        }
        this.get("/pub/check_wxlg_status", { id: this.lg_id }, 'get', false).then((e) => {

          if (e.ok == 0) {
            setTimeout(() => {
              ths.bind2()
            }, 1000);
          }
          if (e.ok == 2) {
            this.show = false
            this.$alert(e.msg, {
              confirmButtonText: 'OK'
            });
            this.$confirm(e.msg, this.$lang(51067), {
              confirmButtonText: this.$lang(51068),
              cancelButtonText: this.$lang(51069),
              type: 'warning'
            }).then(() => {
              this.cache('openid', e.openid)
              this.jump('/reg')
            }).catch(() => {

            });

          }

          if (e.ok == 3) {
            this.show = false
            this.cache('info', e.info);
            this.cache('token', e.token);
            this.$message({
              type: 'success',
              message: this.$lang(42617)
            });
            this.$store.commit('login')
            let url = localStorage.getItem('pcwxbkurl')
            if (url) {
              window.location.href = url
            } else {
              this.jump('/bus_list', {}, true)
            }

          }


        });
      },
      sbmt() {
        if (!this.checked ) {
          this.$message({
            type: 'error',
            message: ` ${this.$lang(70071)}《${this.$lang(70069)}》《${this.$lang(70070)}》   `
          });
          return
        }
        this.get("/pub/login", this.put, 'post').then((e) => {
          this.cache('info', e.info);
          this.cache('token', e.token);
          this.$message({
            type: 'success',
            message: this.$lang(42617)
          });
          this.$store.commit('login')
          let url = localStorage.getItem('pcwxbkurl')
          if (url) {
            window.location.href = url
          } else {
            this.jump('/bus_list', {}, true)
          }


        });
      }
    }
}
</script>

<style scoped>
.wxbox {
  text-align: center;
  display: flex;
  justify-content: center;
}
.tcwx {
  width: 100%;
  text-align: center;
}

.tcqrcode {
  margin: auto;
}

.qrtxt {
  color: green;
  font-size: 16px;
  line-height: 30px;
}
.login{

    width: 1100px;
    height: 100vh;
    background-image: url("~@/../static/image/login.png");
    background-repeat: no-repeat;
    margin: 0 auto;
    z-index: 4;
    display: flex;
    margin-top: 5%;
}
.txtmid {
  line-height: 20px;
}
.login .t1{
    flex: 0 0 50%;
}
.login .t2{
    margin: 0 auto;
    margin-top: 7%;
    display: flex;
    flex-direction: column;
}
.login .inp1{
    margin-bottom: 5%;
    display: flex;
    flex-direction: column;
}
.login .inp1 span{
    margin-left: 5%;
    margin-bottom: 5%;
    color: rgb(33, 37, 41);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0%;
}
.login .inp1 .inp2{
    width: 280px;
    height: 5vh;
    background: rgb(249, 250, 254);
    border-radius: 8px;
}
.login .btn1{
    width: 280px;
    height: 5vh;
    background: rgb(4, 100, 221);
    border-radius: 8px;

}
.login .remark{
    display: flex;
    margin-top: 5%;
}
.login .remark span{
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0%;
    text-align: left;
}
.login .remark2{
    display: flex;
    margin: 0 auto;
    margin-top: 15%;
}
.login .remark2 span{
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0%;

}
.login .t3 {
    margin-top: 3%;
    margin-right: 4%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/login.vue